/**
 * @praesto/core/internal/paths
 *
 * The single chokepoint for Firestore path construction. EVERY tenant-scoped
 * document/collection path in core must be built here so the non-negotiable
 * rule "every doc lives under /tenants/{tenantId}/..." (root CLAUDE.md) is
 * enforced fail-closed: a blank tenant or a separator-injected segment throws
 * rather than silently producing a cross-tenant or escaped path.
 */
const TENANTS = "tenants";

function assertToken(value: string, label: string): void {
  if (value.trim() === "") {
    throw new Error(`[paths] ${label} must be a non-empty string`);
  }
  if (value.includes("/")) {
    throw new Error(`[paths] ${label} must not contain a path separator: "${value}"`);
  }
}

/** `tenants/{tenantId}` — the tenant root document path. */
export function tenantRoot(tenantId: string): string {
  assertToken(tenantId, "tenantId");
  return `${TENANTS}/${tenantId}`;
}

/** `tenants/{tenantId}/{...segments}` — a tenant-scoped path. */
export function tenantPath(tenantId: string, ...segments: ReadonlyArray<string>): string {
  const root = tenantRoot(tenantId);
  if (segments.length === 0) return root;
  segments.forEach((seg, i) => assertToken(seg, `segment[${i}]`));
  return `${root}/${segments.join("/")}`;
}
